(function () {
  // Heuristics for "full-screen overlay" Klaviyo uses
  const isFullscreen = (el) => {
    if (!el || el.nodeType !== 1) return false;
    const cs = getComputedStyle(el);
    if (cs.position !== "fixed") return false;
    const w = el.offsetWidth, h = el.offsetHeight;
    if (w < window.innerWidth * 0.98 || h < window.innerHeight * 0.98) return false;
    // common attributes/classes
    const role = el.getAttribute("role");
    const ariaModal = el.getAttribute("aria-modal");
    const dataTestId = el.getAttribute("data-testid") || "";
    const txt = (el.className || "") + " " + (el.id || "");
    return (
      role === "dialog" ||
      ariaModal === "true" ||
      /klaviyo|kl-private-reset-css|klaviyo-form|klaviyo-overlay|klaviyo-form-host/i.test(txt) ||
      /POPUP/i.test(dataTestId)
    );
  };

  function nukeKlaviyoOverlay() {
    // 1) Remove obvious overlay/dialogs
    const candidates = [
      '[role="dialog"][aria-modal="true"]',
      '[data-testid="klaviyo-overlay"]',
      '.klaviyo-form-overlay',
      '.klaviyo-form-host',
      '.klaviyo-form',
      '[data-testid="POPUP"]', // inner popup; we'll remove its fullscreen parent instead
      '.kl-private-reset-css-Xuajs1'
    ]
      .flatMap(sel => Array.from(document.querySelectorAll(sel)))
      .filter(isFullscreen);

    // Prefer removing their fullscreen parents to avoid content flashes
    const toRemove = new Set();
    candidates.forEach(el => {
      let p = el;
      while (p && p !== document.documentElement) {
        if (isFullscreen(p)) toRemove.add(p);
        p = p.parentElement;
      }
    });

    toRemove.forEach(el => {
      try { el.remove(); } catch {}
    });

    // 2) Ensure no invisible blocker remains at the top
    const probe = (x, y) => document.elementFromPoint(x, y);
    const cx = Math.floor(window.innerWidth / 2);
    const cy = Math.floor(window.innerHeight / 2);
    const topEl = probe(cx, cy);
    if (topEl) {
      const txt = (topEl.className || "") + " " + (topEl.id || "");
      if (isFullscreen(topEl) || /klaviyo|kl-private-reset-css|klaviyo-overlay/i.test(txt)) {
        try { topEl.remove(); } catch {}
      }
    }

    // 3) Unlock scrolling/clicking just in case
    document.body.classList.remove(
      "klaviyo-prevent-body-scrolling",
      "klaviyo-body-scrolling-prevented",
      "klaviyo-no-scroll",
      "klaviyo-disable-scroll"
    );
    document.body.style.overflow = "";
    document.body.style.pointerEvents = "";
    document.documentElement.style.pointerEvents = "";
  }

  function onKlaviyoEvent(e) {
    const t = (e.detail && (e.detail.type || e.detail.event)) || "";
    if (t === "close" || t === "success") {
      // Immediate + delayed to catch fadeout animations
      nukeKlaviyoOverlay();
      setTimeout(nukeKlaviyoOverlay, 50);
      setTimeout(nukeKlaviyoOverlay, 300);
    }
  }

  // Avoid duplicate listeners
  if (window.__klvNukeHandler) {
    window.removeEventListener("klaviyoForms", window.__klvNukeHandler);
    document.removeEventListener("klaviyoForms", window.__klvNukeHandler);
  }
  window.__klvNukeHandler = onKlaviyoEvent;
  window.addEventListener("klaviyoForms", onKlaviyoEvent);
  document.addEventListener("klaviyoForms", onKlaviyoEvent);

  // Mutation watchdog: remove stuck fadeout layers (e.g., animation-name: klaviyo-fadeout)
  if (!window.__klvNukeWatchdog) {
    const obs = new MutationObserver(() => {
      // if no visible popup content but a fullscreen layer exists → remove it
      const anyFields = document.querySelector('.klaviyo-form input, [data-testid="POPUP"] input');
      const overlays = Array.from(document.querySelectorAll('*'))
        .filter(el => isFullscreen(el) && /fadeout|klaviyo-overlay|klaviyo-form/i.test(el.getAttribute("style") || el.className || ""));
      if (!anyFields && overlays.length) overlays.forEach(el => { try { el.remove(); } catch {} });
    });
    obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
    window.__klvNukeWatchdog = obs;
  }

  // Run once now
  nukeKlaviyoOverlay();
  console.log("🧹 Klaviyo overlay cleaner active. Will auto-remove stuck modals and restore clicks/scroll.");
})();








(function () {
  // Ensure DL exists
  window.dataLayer = window.dataLayer || [];

  // --- fetch hook (modern themes) ---
  const origFetch = window.fetch;
  window.fetch = async function(resource, init) {
    // Normalize URL (resource can be a Request or string)
    const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    const isATC = url.indexOf('/cart/add.js') !== -1;

    const res = await origFetch.apply(this, arguments);

    if (isATC) {
      try {
        const clone = res.clone();
        const data = await clone.json(); // JSON returned by Shopify add.js
        console.log('🛒 ATC via fetch → response:', data);

        // Push clean event for GTM
        window.dataLayer.push({
          event: 'shopify_add_to_cart',
          ecommerce: {
            items: [{
              id: data.variant_id || data.id,      // variant id
              quantity: data.quantity || 1,
              item_name: data.product_title,
              item_variant: data.variant_title,
              price: data.price ? data.price/100 : undefined,
              currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined
            }]
          }
        });
        console.log('📤 Pushed event → shopify_add_to_cart');
      } catch (e) {
        console.warn('ATC fetch hook: could not parse JSON response', e);
      }
    }

    return res;
  };

  // --- XHR hook (older themes/apps) ---
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.__isATC = (url || '').indexOf('/cart/add.js') !== -1;
    return _open.apply(this, arguments);
  };
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(body) {
    if (this.__isATC) {
      this.addEventListener('load', function() {
        try {
          const data = JSON.parse(this.responseText);
          console.log('🛒 ATC via XHR → response:', data);

          window.dataLayer.push({
            event: 'shopify_add_to_cart',
            ecommerce: {
              items: [{
                id: data.variant_id || data.id,
                quantity: data.quantity || 1,
                item_name: data.product_title,
                item_variant: data.variant_title,
                price: data.price ? data.price/100 : undefined,
                currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined
              }]
            }
          });
          console.log('📤 Pushed event → shopify_add_to_cart');
        } catch (e) {
          console.warn('ATC XHR hook: could not parse response JSON', e);
        }
      });
    }
    return _send.apply(this, arguments);
  };
})();


// ATTTEMTS TO BYPASS THE PRE-ORDER REDIRECT TO CART PAGE
// (function () {
//   // Ensure DL exists
//   window.dataLayer = window.dataLayer || [];

//   // --- fetch hook (modern themes) ---
//   const origFetch = window.fetch;
//   window.fetch = async function(resource, init) {
//     const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
//     const isATC = url.includes('/cart/add.js');

//     const res = await origFetch.apply(this, arguments);

//     if (isATC) {
//       try {
//         const clone = res.clone();
//         const data = await clone.json();
//         console.log('🛒 ATC via fetch → response:', data);

//         // Push clean event for GTM
//         window.dataLayer.push({
//           event: 'shopify_add_to_cart',
//           ecommerce: {
//             items: [{
//               id: data.variant_id || data.id,
//               quantity: data.quantity || 1,
//               item_name: data.product_title,
//               item_variant: data.variant_title,
//               price: data.price ? data.price/100 : undefined,
//               currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined
//             }]
//           }
//         });
//         console.log('📤 Pushed event → shopify_add_to_cart');

//         // 🧩 NEW: open drawer after add-to-cart
//         openCartDrawer();

//       } catch (e) {
//         console.warn('ATC fetch hook: could not parse JSON response', e);
//       }
//     }

//     return res;
//   };

//   // --- XHR hook (older themes/apps) ---
//   const _open = XMLHttpRequest.prototype.open;
//   XMLHttpRequest.prototype.open = function(method, url) {
//     this.__isATC = (url || '').includes('/cart/add.js');
//     return _open.apply(this, arguments);
//   };
//   const _send = XMLHttpRequest.prototype.send;
//   XMLHttpRequest.prototype.send = function(body) {
//     if (this.__isATC) {
//       this.addEventListener('load', function() {
//         try {
//           const data = JSON.parse(this.responseText);
//           console.log('🛒 ATC via XHR → response:', data);

//           window.dataLayer.push({
//             event: 'shopify_add_to_cart',
//             ecommerce: {
//               items: [{
//                 id: data.variant_id || data.id,
//                 quantity: data.quantity || 1,
//                 item_name: data.product_title,
//                 item_variant: data.variant_title,
//                 price: data.price ? data.price/100 : undefined,
//                 currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined
//               }]
//             }
//           });
//           console.log('📤 Pushed event → shopify_add_to_cart');

//           // 🧩 NEW: open drawer after add-to-cart
//           openCartDrawer();

//         } catch (e) {
//           console.warn('ATC XHR hook: could not parse response JSON', e);
//         }
//       });
//     }
//     return _send.apply(this, arguments);
//   };

//   // 🔹 Function to open the cart drawer safely
//   function openCartDrawer() {
//     setTimeout(() => {
//       const drawerButton = document.querySelector('a[aria-controls="cart-drawer"]');
//       if (drawerButton) {
//         drawerButton.click();
//         console.log('✅ Cart drawer opened after add-to-cart');
//       } else {
//         console.warn('⚠️ Cart drawer button not found');
//       }
//     }, 150);
//   }

//   // // 🔹 Intercept redirects to /cart
//   // const originalAssign = window.location.assign;
//   // const originalReplace = window.location.replace;
//   // const blockCartRedirect = url => {
//   //   if (typeof url === 'string' && url.includes('/cart')) {
//   //     console.log('⛔ Redirect to cart prevented');
//   //     return true;
//   //   }
//   //   return false;
//   // };
//   // window.location.assign = function(url) {
//   //   if (!blockCartRedirect(url)) originalAssign.call(window.location, url);
//   // };
//   // window.location.replace = function(url) {
//   //   if (!blockCartRedirect(url)) originalReplace.call(window.location, url);
//   // };

//     // 🔹 Intercept *any* redirect to /cart
//   (function interceptRedirects() {
//     const blockCartRedirect = (url) => {
//       if (typeof url === 'string' && url.includes('/cart')) {
//         console.log('⛔ Redirect to cart prevented');
//         openCartDrawer();
//         return true;
//       }
//       return false;
//     };

//     // Hook assign & replace
//     const originalAssign = window.location.assign;
//     const originalReplace = window.location.replace;
//     window.location.assign = function (url) {
//       if (!blockCartRedirect(url)) return originalAssign.call(window.location, url);
//     };
//     window.location.replace = function (url) {
//       if (!blockCartRedirect(url)) return originalReplace.call(window.location, url);
//     };

//     // Hook direct href assignment (the sneaky one)
//     Object.defineProperty(window.location, 'href', {
//       set: function (url) {
//         if (!blockCartRedirect(url)) window.location.assign(url);
//       },
//       get: function () {
//         return document.createElement('a').href;
//       }
//     });

//     // Hook document.location too (just in case)
//     Object.defineProperty(document, 'location', {
//       set: function (url) {
//         if (!blockCartRedirect(url)) window.location.assign(url);
//       },
//       get: function () {
//         return window.location;
//       }
//     });

//     console.log('🛑 Cart redirect interception active');
//   })();


// })();

// (function blockCartNavigations() {
//   function stopCartNavigation(e) {
//     const href =
//       (e.target && e.target.href) ||
//       (e.target && e.target.action) ||
//       '';

//     if (typeof href === 'string' && href.includes('/cart')) {
//       e.preventDefault();
//       e.stopImmediatePropagation();
//       console.log('🛑 Form or link redirect to /cart prevented');
//       openCartDrawer();
//       return false;
//     }
//   }

//   // Catch clicks on links or buttons that go to /cart
//   document.addEventListener('click', stopCartNavigation, true);

//   // Catch form submissions that post to /cart
//   document.addEventListener('submit', stopCartNavigation, true);

//   // As a last resort, intercept any top-level navigation
//   window.addEventListener('beforeunload', function (e) {
//     const nextURL = document.activeElement?.href || '';
//     if (nextURL.includes('/cart')) {
//       console.log('🛑 beforeunload redirect to /cart prevented');
//       e.preventDefault();
//       openCartDrawer();
//       return false;
//     }
//   });

//   console.log('🚫 Deep cart redirect interception active');
// })();


// // 🚧 Intercept top-frame cart redirects (final fallback)
// (function interceptTopLocation() {
//   try {
//     const topLoc = Object.getOwnPropertyDescriptor(window.top, 'location');
//     if (!topLoc || !topLoc.set) {
//       Object.defineProperty(window.top, 'location', {
//         configurable: true,
//         enumerable: true,
//         set: function (url) {
//           if (typeof url === 'string' && url.includes('/cart')) {
//             console.log('🧱 Blocked window.top.location redirect to /cart');
//             openCartDrawer();
//           } else {
//             window.location.assign(url);
//           }
//         },
//         get: function () {
//           return window.location;
//         }
//       });
//       console.log('🛡 window.top.location interception active');
//     }
//   } catch (err) {
//     console.warn('Could not patch window.top.location:', err);
//   }
// })();




document.addEventListener('click', function(e) {
  const cartButton = e.target.closest('a.full-width-row__button[href="/cart"]');
  if (cartButton) {
    e.preventDefault();
    const drawerButton = document.querySelector('a[aria-controls="cart-drawer"]');
    if (drawerButton) drawerButton.click();
  }
});


